import React, { useState, useEffect } from 'react';
import { AdminSidebar } from './Dashboard';
import api from '../../services/api';

const TIPOS  = ['consorcio','seguro','selante','produto','evento','parceiro','institucional'];
const LOCAIS = ['ticker','hero','meio_landing','area_compra','entre_cards','pagina_veiculo','area_produtos','area_interna'];
const BLANK  = { titulo:'', texto:'', tipo:'consorcio', local_exibicao:'ticker', botao_texto:'', link_destino:'', link_tipo:'whatsapp', status:'ativa', ordem:0 };

export default function AdminCampanhas() {
  const [campanhas, setCampanhas] = useState([]);
  const [form, setForm]   = useState(BLANK);
  const [editId, setEditId] = useState(null);
  const [salvando, setSalvando] = useState(false);

  const carregar = () => api.get('/admin/campanhas').then(({ data }) => setCampanhas(data)).catch(() => {});
  useEffect(() => { carregar(); }, []);

  const upd = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const salvar = async e => {
    e.preventDefault(); setSalvando(true);
    try {
      if (editId) await api.patch(`/admin/campanhas/${editId}`, form);
      else        await api.post('/admin/campanhas', form);
      setForm(BLANK); setEditId(null); carregar();
    } finally { setSalvando(false); }
  };

  const excluir = async id => { if (window.confirm('Excluir campanha?')) { await api.delete(`/admin/campanhas/${id}`); carregar(); } };
  const editar  = c => { setForm({ ...c }); setEditId(c.id); };
  const toggle  = async (id, status) => { await api.patch(`/admin/campanhas/${id}`, { status: status==='ativa'?'inativa':'ativa' }); carregar(); };
  const cancelar = () => { setForm(BLANK); setEditId(null); };

  return (
    <div className="admin-layout">
      <AdminSidebar />
      <div className="admin-content">
        <div className="admin-header"><h1 className="admin-title">Campanhas internas</h1></div>

        {/* Form */}
        <div className="card" style={{ padding:'28px 32px', marginBottom:28 }}>
          <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:18, marginBottom:20 }}>{editId ? 'Editar campanha' : 'Nova campanha'}</h3>
          <form onSubmit={salvar}>
            <div className="form-row">
              <div className="form-group"><label>Título *</label><input name="titulo" value={form.titulo} onChange={upd} required /></div>
              <div className="form-group"><label>Tipo</label>
                <select name="tipo" value={form.tipo} onChange={upd}>{TIPOS.map(t=><option key={t}>{t}</option>)}</select>
              </div>
            </div>
            <div className="form-group"><label>Texto curto</label><textarea name="texto" value={form.texto} onChange={upd} rows={2} /></div>
            <div className="form-row">
              <div className="form-group"><label>Local de exibição</label>
                <select name="local_exibicao" value={form.local_exibicao} onChange={upd}>{LOCAIS.map(l=><option key={l}>{l}</option>)}</select>
              </div>
              <div className="form-group"><label>Status</label>
                <select name="status" value={form.status} onChange={upd}><option value="ativa">Ativa</option><option value="inativa">Inativa</option></select>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group"><label>Texto do botão</label><input name="botao_texto" value={form.botao_texto} onChange={upd} /></div>
              <div className="form-group"><label>Link de destino</label><input name="link_destino" value={form.link_destino} onChange={upd} /></div>
            </div>
            <div className="form-row">
              <div className="form-group"><label>Tipo de link</label>
                <select name="link_tipo" value={form.link_tipo} onChange={upd}><option value="whatsapp">WhatsApp</option><option value="externo">Externo</option><option value="interno">Interno</option></select>
              </div>
              <div className="form-group"><label>Ordem</label><input name="ordem" type="number" value={form.ordem} onChange={upd} /></div>
            </div>
            <div style={{ display:'flex', gap:10 }}>
              <button type="submit" className="btn btn-primary btn-sm" disabled={salvando}>{salvando?'Salvando…': editId?'Salvar':'Criar campanha'}</button>
              {editId && <button type="button" className="btn btn-outline btn-sm" onClick={cancelar}>Cancelar</button>}
            </div>
          </form>
        </div>

        {/* Tabela */}
        <table className="tabela">
          <thead><tr><th>Título</th><th>Tipo</th><th>Local</th><th>Ordem</th><th>Status</th><th>Ações</th></tr></thead>
          <tbody>
            {campanhas.map(c => (
              <tr key={c.id}>
                <td style={{ fontWeight:700 }}>{c.titulo}</td>
                <td><span className="badge badge-basico">{c.tipo}</span></td>
                <td style={{ fontSize:12, color:'var(--ink-muted)' }}>{c.local_exibicao}</td>
                <td style={{ fontWeight:700 }}>{c.ordem}</td>
                <td><span className={`badge badge-${c.status==='ativa'?'ativa':'cancelada'}`}>{c.status}</span></td>
                <td style={{ display:'flex', gap:8 }}>
                  <button className="btn btn-outline btn-sm" onClick={() => editar(c)}>Editar</button>
                  <button className="btn btn-sm" style={{ background: c.status==='ativa'?'#c85718':'#1e7d47', color:'#fff', border:'none', borderRadius:'var(--r-sm)', padding:'6px 12px', cursor:'pointer', fontSize:10, fontWeight:900 }} onClick={() => toggle(c.id, c.status)}>{c.status==='ativa'?'Desativar':'Ativar'}</button>
                  <button className="btn btn-danger btn-sm" onClick={() => excluir(c.id)}>✗</button>
                </td>
              </tr>
            ))}
            {campanhas.length===0 && <tr><td colSpan={6} style={{ textAlign:'center', color:'var(--ink-muted)', padding:36 }}>Nenhuma campanha cadastrada.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
